<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        {{ $t("HomePage.HomePage") }}
        <!-- Dashboard -->
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("ProductDetails.ProductList") }}
        <!-- รายการสินค้า -->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <!-- Filters -->
    <!-- <product-list-filters
      :product-name-filter.sync="productNameFilter"
      :product-category-filter="productCategoryFilter"
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>
              {{ $t("ProductDetails.Show") }}
              <!-- Show -->
            </label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t("ProductDetails.Entries") }}
              <!-- entries -->
            </label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('ProductDetails.Search')"
              />
              <b-button
                variant="primary"
                :to="{ name: 'product' }"
              >
                <span
                  class="text-nowrap"
                >{{ $t("ProductDetails.AddNewProduct") }}
                  <!-- + เพิ่มสินค้าใหม่ -->
                </span>
              </b-button>
              &nbsp;
              <b-button
                variant="primary"
                @click="exportExcel()"
              >
                <span
                  class="text-nowrap"
                >Export Excel
                  <!-- + เพิ่มสินค้าใหม่ -->
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refProductListTable"
        class="position-relative"
        :items="fetchProducts"
        responsive
        :fields="tableColumns_i18n"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('ProductDetails.ProductInformationNotFound')"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(index)="data">
          <div style="text-align: center;">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
            </div>
        </template>
        
        <template #cell(name)="data">
          <b-media vertical-align="center">
            <!-- <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.productName)"
                :to="{ name: 'product-view', params: { id: data.item.id } }"
              />
            </template> -->
            <b-link
              :to="{ name: 'product-edit', params: { id: data.item.id } }"
              class="font-weight-bold d-block"
              style="width: 15rem;"
            >
              {{ data.item.name }}
            </b-link>
          </b-media>
        </template>

        <template #cell(moreOptions)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.moreOptions)}`"
            class="text-capitalize"
          >
            {{ data.item.moreOptions }}
          </b-badge>
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(price)="data">
          <span>{{ data.item.price.toLocaleString("en-US") }}
            {{ $t("ProductDetails.Baht") }}
            <!-- บาท -->
          </span>
        </template>

        <template #cell(sales)="data">
          <span>{{ data.item.sales.toLocaleString("en-US") }}
            <!-- {{ $t("ProductDetails.Kg") }} -->
            <!-- kg -->
          </span>
        </template>

        <template #cell(stockQuantity)="data">
          <span>{{ data.item.stockQuantity.toLocaleString("en-US") }}
            <!-- {{ $t("ProductDetails.Kg") }} -->
            <!-- kg -->
          </span>
        </template>

        <template #cell(isPublished)="data">
          <span>{{ data.item.isPublished == true ? 'เผยแพร่' : 'ไม่เผยแพร่' }}
          </span>
        </template>

        <!--  -->

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              :to="{ name: 'product-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Edit") }}
                <!-- Edit -->
              </span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteitem(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Delete") }}
              </span>
            </b-dropdown-item>
            <!-- <b-dropdown-item @click="deleteitem(data.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">
                {{ $t("ProductDetails.Delete") }}
              </span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              {{ $t("ProductDetails.Showing") }}
              <!-- Showing  -->
              {{ dataMeta.from }}
              {{ $t("ProductDetails.to") }}
              <!-- to  -->
              {{ dataMeta.to }}
              {{ $t("ProductDetails.of") }}
              <!-- of -->
              {{ dataMeta.of }}
              {{ $t("ProductDetails.Entries") }}
              <!-- entries -->
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalProducts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBreadcrumb,
  BBreadcrumbItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
// import ProductListFilters from './ProductListFilters.vue'
import { getUserData } from '@/auth/utils'
import { stringToNumber } from '@/common'
import exportFromJSON from 'export-from-json'
import axios, { baseURL } from '@axios'
import * as XLSX from 'xlsx'
import useProductList from './useProductList'
import productStoreModule from './productStoreModule'

export default {
  components: {
    // ProductListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBreadcrumb,
    BBreadcrumbItem,

    vSelect,
  },
  setup() {
    // Register module
    if (!store.hasModule('product')) { store.registerModule('product', productStoreModule) }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('product')) store.unregisterModule('product')
    })

    // const titleOptions = [
    //   { label: 'Mr.', value: 'Mr.' },
    //   { label: 'Mrs.', value: 'Mrs.' },
    //   { label: 'Ms.', value: 'Ms.' },
    // ]

    const statusOptions = [
      { label: 'Pending', value: 'Pending' },
      { label: 'Active', value: 'Active' },
      { label: 'Inactive', value: 'Inactive' },
    ]

    const {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      refetchData,

      // UI
      resolveStatusVariant,

      // Extra Filters
      productNameFilter,
      productCategoryFilter,
      statusFilter,
    } = useProductList()

    return {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveStatusVariant,

      // titleOptions,
      statusOptions,

      // Extra Filters
      productNameFilter,
      productCategoryFilter,
      statusFilter,
    }
  },
  computed: {
    tableColumns_i18n() {
      return [
        { key: 'index',
        label: this.$t('ProductDetails.Number')
        },
        {
          key: 'productCode',
          label: this.$t('ProductDetails.SKUnumber'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('ProductDetails.ProductName'),
          sortable: true,
        },
        {
          key: 'categoryName',
          label: this.$t('ProductDetails.ProductCategory'),
          sortable: true,
        },
        {
          key: 'price',
          label: this.$t('ProductDetails.Price'),

          sortable: true,
        },
        {
          key: 'stockQuantity',
          label: this.$t('ProductDetails.Warehouse'),

          sortable: true,
        },
        {
          key: 'totalQuantity',
          label: this.$t('ProductDetails.Sales'),

          sortable: true,
        },
        {
          key: "isPublished",
          label: this.$t("ProductDetails.isPublished"),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('ProductDetails.Actions'),

          sortable: true,
        },
      ]
    },
  },
  methods: {
      deleteitem(item) {
      console.log('deleteitem', item)

      if (confirm('คุณต้องการที่จะลบสินค้าใช่ไหม ?')) {
        const userData = getUserData()

        axios.delete(`${baseURL}/api/Product/Delete?productId=${item}`,
        {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => {
            if (response.status === 200) {
              this.$router.go(this.$router.currentRoute)
            }
          })
          .catch(error => {
          // this.disabledButton = false
          // this.isShowLoading = false
            this.isLoading = false
            this.showToast('danger', 'XCircleIcon', error)
          })
      }
    },
    // deleteitem(item) {
    //   console.log(item)

    //   if (confirm('คุณต้องการที่จะลบสินค้าใช่ไหม ?')) {
    //     const userData = getUserData()

    //     const saveModel = {
    //       productId: item.id,
    //       shopId: userData.shopId,
    //       isPublished: false,

    //     }

    //     console.log('saveModel', saveModel)

    //     store
    //       .dispatch('product/addProduct', saveModel)
    //       .then(response => {
    //         if (response.status === 200) {
    //           this.$router.go(this.$router.currentRoute)
    //         }
    //       })
    //       .catch(error => {
    //       // this.disabledButton = false
    //       // this.isShowLoading = false
    //         this.isLoading = false
    //         this.showToast('danger', 'XCircleIcon', error)
    //       })
    //   }
    // },
    exportExcel() {
      const userData = getUserData()

      const body = {
        pagination: {
          total: 0,
          current: 1,
          pageSize: 20000,
          // current: queryParams.page,
          // pageSize: queryParams.perPage,
        },
        search: {
          name: null,
          // name: '',
          startPrice: null,
          endPrice: null,
          shopId: userData.shopId,
          categoryId: null,
          hasOptions: null,
          isVisibleIndividually: null,
          isFeatured: null,
          isAllowToOrder: null,
          isPublished: null,
          isChecking: null,
          isViolation: null,
          sku: null,
          categoryIds: [

          ],
          includeSubCategories: true,
          outOfStock: null,
          isActive: true,
        },
        sort: {
          predicate: 'created_date',
          // predicate: queryParams.sortBy,
          reverse: true,
        },
      }

      axios
        .post(`${baseURL}/api/Product/GetList`, body, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${userData.token}`,
          },
        })
        .then(response => {
          console.log(response)

          const filteredData = response.data.data.list
          const result = filteredData.map(x => (
            {
              ชื่อสินค้า: x.name,
              รหัสสินค้า: x.productCode,
              ประเภทสินค้า: x.categoryName,
              ราคา: x.price,
              สินค้าในสต๊อก: x.stockQuantity,
              ยอดขายสินค้า: x.totalQuantity,
            }))

          console.log(filteredData)
          const productWS = XLSX.utils.json_to_sheet(result)
          // const pokemonWS = XLSX.utils.json_to_sheet(filteredData)

          const wb = XLSX.utils.book_new() // make Workbook of Excel

          // add Worksheet to Workbook
          // Workbook contains one or more worksheets
          XLSX.utils.book_append_sheet(wb, productWS, 'product') // sheetAName is name of Worksheet
          // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

          // export Excel file
          XLSX.writeFile(wb, 'รายการสินค้า.xlsx') // name of the file is 'book.xlsx'
        })
        .catch(error => console.log(error))
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
